/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Col_ChangesInputs */

const cs_ebr_col_changes = /** @type {(inputs: Ebr_Col_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny`)
};

const en_ebr_col_changes = /** @type {(inputs: Ebr_Col_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Ebr_Col_ChangesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_col_changes = /** @type {((inputs?: Ebr_Col_ChangesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Col_ChangesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_col_changes(inputs)
	return cs_ebr_col_changes(inputs)
});